import React, {useContext, useState} from "react";
import {ModalContext} from "../../contexts/modal/ModalContext";
import {Button, Modal} from "react-bootstrap";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";

import './InfoModal.css';
const InfoModal = () => {
    const intl = useIntl();
    const [modalContext, setModalContext] = useContext(ModalContext);

    const onCloseClick = () => setModalContext({
        isShow: false,
        title: '',
        content: '',
        onConfirm: () => {},
    });
    const onConfirmClick = () => {
        modalContext.onConfirm();
        onCloseClick();
    }


    return (
        <Modal
            show={modalContext.isShow}
            onHide={onCloseClick}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalContext.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={'modal-content'}>
                {modalContext.content}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCloseClick}>
                    {intl.formatMessage(messages.cancelButtonLabel)}
                </Button>
                <Button variant="primary" onClick={onConfirmClick}>
                    {intl.formatMessage(messages.confirmButtonLabel)}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default InfoModal;